module.exports = __webpack_public_path__ + "static/media/MobileBanner.1a2d80d7.png";